/**
 * Copyright © 2025 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import React from "react";
import camelize from "../../utils/camelize";
import { Loader } from "../loader";
import { IndexTable } from "../index_table";

export const RestaurantGroupTable = ({
  data,
  itemsPerPage,
  setItemsPerPage,
  page,
  setPage,
  pageCount,
  fetchingLoader,
  showDownloadButton,
  disableDownloadButton,
  handleExportCsv,
  csvLoading,
  sortBy,
  sortOrder,
  onSort,
}) => {
  const TableColumns = [
    { key: "id", sortable: true },
    { key: "name", sortable: true },
    // Added key as restaurant_sub_groups_count, because restaurant_sub_groups is an array and we need to sort by the count of sub groups
    { key: "restaurant_sub_groups_count", label: "Restaurant Sub Groups", sortable: true },
    { key: "created_at", sortable: true },
    { key: "partners_count", label: "Partners", sortable: true },
    { key: "actions", sortable: false },
  ];

  const columns = TableColumns?.map((column) => {
    return {
      key: column.key,
      label: column.label || camelize(column.key),
      sortable: column.sortable,
    };
  });

  return (
    <React.Fragment>
      {
        fetchingLoader ? (
          <Loader />
        ) : (
          <IndexTable
            report={false}
            columns={columns}
            data={data}
            tableId="restaurant-groups"
            type="entries"
            itemsPerPage={itemsPerPage}
            setItemsPerPage={setItemsPerPage}
            page={page}
            setPage={setPage}
            pageCount={pageCount}
            showDownloadButton={showDownloadButton}
            disableDownloadButton={disableDownloadButton}
            handleExportCsv={handleExportCsv}
            csvLoading={csvLoading}
            serverSort={true}
            sortBy={sortBy}
            sortOrder={sortOrder}
            onSort={onSort}
          />
        )
      }
    </React.Fragment>
  )
}
